// extracted by mini-css-extract-plugin
export default {"plans-container":"ProjectPlans_plans-container__lGuvW","plans-stack":"ProjectPlans_plans-stack__roBBp","plans-stack-button-row":"ProjectPlans_plans-stack-button-row__f3ISO"};